<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div class="title">{{ pageTitle | uppercase }}</div>
<div fxLayout="row" class="cards row">
  <app-dashboard-card
    [loading]="loading"
    cardTitle="Execution Start"
    i18n-cardTitle="@@startExecution"
    [dateCardContent]="startDate"
    [color]="'#6c8f80'"
    [isDate]="true"
  ></app-dashboard-card>

  <app-dashboard-card
    [loading]="loading"
    cardTitle="Execution End"
    i18n-cardTitle="@@endExecution"
    [dateCardContent]="endDate"
    [color]="'#d89849'"
    [isDate]="true"
  ></app-dashboard-card>

  <app-dashboard-card
    [loading]="loading"
    cardTitle="Median Time For All Employees"
    i18n-cardTitle="@@medianTimeForAllEmployees"
    [cardContent]="medianTimeForAllEmployees"
    type="Hours"
    i18n-type="@@employeeDashboardHours"
    [pipe]="'1.2-2'"
    [color]="'#777a7f'"
  ></app-dashboard-card>

  <app-dashboard-card
    [loading]="loading"
    cardTitle="Median Time For This Employee"
    i18n-cardTitle="@@medianTimeForThisEmployee"
    [cardContent]="medianTimeForThisEmployee"
    type="Hours"
    i18n-type="@@employeeDashboardHours"
    [pipe]="'1.2-2'"
    [color]="'#c06a68'"
  ></app-dashboard-card>
</div>

<div class="graph-cards">
  <div class="bar-chart-card">
    <mat-card>
      <mat-card-title i18n="@@barChartGraph"> Bar Chart Graph </mat-card-title>
      <mat-card-content>
        <div>
          <p-chart
            *ngIf="barChartDataObject"
            height="218"
            type="bar"
            [data]="barChartDataObject.barChartData"
            [options]="barChartDataObject.barChartOptions"
          ></p-chart>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
